export interface QuestionnaireItem {
  key: string;
  title: string;
}

/** Default matnasnet questionnaire — titles are i18n keys resolved in the component */
export const DEFAULT_APP_QUESTIONNAIRE_QUESTIONS: QuestionnaireItem[] = [
  {
    key: 'dailyProductivity',
    title: 'AppQuestionnaire.q1',
  },
  {
    key: 'uiIntuitive',
    title: 'AppQuestionnaire.q2',
  },
  {
    key: 'stabilitySpeed',
    title: 'AppQuestionnaire.q3',
  },
  {
    key: 'functionalityNeeds',
    title: 'AppQuestionnaire.q4',
  },
  {
    key: 'recommendToPeer',
    title: 'AppQuestionnaire.q5',
  },
];

export const DEFAULT_OPEN_FEEDBACK = {
  title: 'AppQuestionnaire.openTitle',
  placeholder: 'AppQuestionnaire.openPlaceholder',
};



// WEBPACK FOOTER //
// ./src/components/app-questionnaire/app-questionnaire.model.ts